import type { ActiveOrg } from '../auth/activeOrg';
import { NO_ACTIVE_ORG } from '../auth/activeOrg';
import { useApiServices } from './useApiServices';

/**
 * The only sanctioned way to read org context.
 *
 * Nothing outside the two `useActiveOrgValue` call sites should reach for `useAuth().orgId`
 * directly. Clerk's value is only half the answer — it is null on a cold offline boot and while a
 * `choose-organization` task is pending, and it never carries our own `organizations.id` uuid.
 *
 * Returns `NO_ACTIVE_ORG` rather than throwing in an app that mounts `ApiServicesProvider` without
 * an org (the marketing sites): "no organization" is a legitimate state there, not a wiring bug.
 * A missing provider still throws, via `useApiServices`.
 */
export const useActiveOrg = (): ActiveOrg => {
  const { activeOrg } = useApiServices();

  return activeOrg ?? NO_ACTIVE_ORG;
};
